import { Component, Input, OnInit } from '@angular/core';
import { ReportsService } from '../../../services/reports.service';
import { AuthService } from '../../../services/auth.service';
import { AclService } from '../../../services/acl.service';
import { ModalService } from '../../../services/modal.service';
import { ModalStates } from '../../../models/modal';
import { downloadFile } from '../../../tools/reports-tools';
import { ReportDownloadArgs, ReportGeneratedArgs } from '../../../models/reports';

@Component({
  selector: 'lib-on-demand-root',
  templateUrl: './on-demand-root.component.html',
  styleUrls: ['./on-demand-root.component.css'],
  standalone: false
})
export class OnDemandRootComponent implements OnInit {
  @Input()
  public clientCode: string;

  public availableReports: { Id: number; Value: string }[] = [];
  public chosenReport: number;

  public showHtml = false;
  public html: string = '';
  public hideJumbo: boolean = false;

  constructor(
    private reportService: ReportsService,
    private authService: AuthService,
    private aclService: AclService,
    private modalService: ModalService
  ) {}

  ngOnInit(): void {
    this.aclService.HasMinimumRoleByName(this.authService.user.UserId, 'CSR1').subscribe(result => {
      if (result) {
        this.availableReports.push({ Id: -1, Value: 'Payroll Audit Log' });
        this.availableReports.push({ Id: -2, Value: 'People Changes' });
      }
      this.chosenReport = null;
      this.reportService.getOnDemandReportsList(this.clientCode).subscribe(reports => {
        this.availableReports.push(...reports);
        this.availableReports = this.availableReports.sort(this._sortReports);
      });
    });
  }

  displayHtmlReport(htmlArgs: ReportGeneratedArgs) {
    this.reportService
      .dynamicReport(htmlArgs.args, 'text/html', this.clientCode, htmlArgs.endpoint)
      .subscribe((result: any) => {
        if (result == null) {
          this.modalService.showAlertModal(
            'The report parameters that you entered did not generate any results. Please try again with different parameters.',
            ModalStates.Error
          );
        } else {
          const blob = new Blob([result], { type: 'text/html' });
          blob.text().then(text => {
            this.showHtml = true;
            const div = document.getElementById('htmlOutput');
            div.innerHTML = text;
            div.querySelector('table').classList.add('w-100');
          });
        }
      });
  }

  public downloadReport(downloadArgs: ReportDownloadArgs) {
    let mimeType = '';
    switch (downloadArgs.format) {
      case 'csv':
        mimeType = 'text/csv';
        break;
      case 'pdf':
        mimeType = 'application/pdf';
        break;
      case 'xlsx':
        mimeType = 'application/vnd.ms-excel';
        break;
      default:
        this.modalService.showAlertModal(
          'Unsupported download foramt. Please choose a format and try again.',
          ModalStates.Error
        );
    }

    this.reportService
      .dynamicReport(downloadArgs.args, mimeType, this.clientCode, downloadArgs.endpoint)
      .subscribe((result: any) => {
        if (result == null) {
          this.modalService.showAlertModal(
            'The report parameters that you entered did not generate any results. Please try again with different parameters.',
            ModalStates.Error
          );
        } else {
          downloadFile(result, downloadArgs.filename);
        }
      });
  }

  public reportTypeChanged(val: number) {
    this.hideJumbo = true;
    this.chosenReport = +val;
    const div = document.getElementById('htmlOutput');
    div.innerHTML = '';
    this.showHtml = false;
  }

  private _sortReports(a: { Id: number; Value: string }, b: { Id: number; Value: string }) {
    if (a.Value < b.Value) {
      return -1;
    }
    if (a.Value > b.Value) {
      return 1;
    }
    return 0;
  }
}
